import { prepareUrl } from 'utils/url'

// A raw campaigns-list row (snake_case, no transformer unlike the detail Campaign); fields are those the list/review tables read.
export type CampaignListRow = {
  id: number
  title: string
  customer_name: string
  status: string
  countries: string[]
  start_date: string
  end_date: string
  days_till_end: number
  matched_views: number
  total_views: number
  plan: number
  completion: number
  payment_method: string
  is_partner: boolean
  adops_id: number | null
}

// Build the campaigns list query; filters (status/countries/adops/customers) are arrays that prepareUrl comma-joins, dropping empties.
export const getCampaignsQuery = meta =>
  prepareUrl({
    limit: meta.rowsPerPage,
    offset: meta.page * meta.rowsPerPage,
    status: meta.filters.status,
    countries: meta.filters.countries,
    paid: meta.filters.paidStatus,
    query: meta.filters.query,
    adops: meta.filters.adops,
    customer_id: meta.filters.customers || [],
    from: meta.filters.period?.from,
    to: meta.filters.period?.to,
    sort_by: meta.sortBy,
    sort_order: meta.sortOrder,
  })
